import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';
export const accountStatementGenerationRoutes: Routes = [{ path: 'funds/account-statement-generation', loadComponent: () => import('./account-statement-generation.component').then(m => m.AccountStatementGenerationComponent), canActivate: [AuthGuard] }];
